module.exports = __webpack_public_path__ + "static/media/tips-icon.0003bde8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tips-icon.png
// module id = 200
// module chunks = 6